<!-- 外部菜单 -->

<template>
  <div>
    <keep-alive>
      <mainD v-if="isShow" :key="$route.fullPath" @upMain="upMain"></mainD>
    </keep-alive>
  </div>
</template>

<script>
import mainD from "./main.vue";
export default {
  name: 'qualityStatement',
  components: { mainD },

  data() {
    return {
      isShow: true,
      key:1
    }

  },
created(){

    console.log(this.$route.fullPath,"$route.fullPath的值777");
    // this.key=this.$route.query.index
  

},
watch: {

  },


  methods: {
    upMain() {
      console.log('555')
this.isShow = false;
      this.$nextTick(() => {
        this.isShow = true;
      })

    }
  }

};

</script>

